import { render, staticRenderFns } from "./CardIcon.vue?vue&type=template&id=03f01127&scoped=true"
import script from "./CardIcon.vue?vue&type=script&lang=ts"
export * from "./CardIcon.vue?vue&type=script&lang=ts"
import style0 from "./CardIcon.vue?vue&type=style&index=0&id=03f01127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f01127",
  null
  
)

export default component.exports